var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.72787 0 0 6.72787 0 15C0 23.2721 6.72787 30 15 30C23.2721 30 30 23.2721 30 15C30 6.72787 23.2721 0 15 0ZM15 4.62C17.8081 4.62 20.0887 6.90368 20.0887 9.70875C20.0887 12.5138 17.8095 14.8005 15 14.8005C12.1919 14.8005 9.91125 12.5168 9.91125 9.70875C9.91125 6.90067 12.1905 4.62 15 4.62ZM23.1608 22.3725C21.0836 24.6826 18.1057 26.0024 15 26.0024C11.8942 26.0024 8.92088 24.6826 6.83925 22.3725C6.64003 22.1557 6.53163 21.8701 6.53163 21.5624C6.53163 18.6152 8.93103 16.2142 11.8829 16.2142H18.1158C21.0674 16.2142 23.467 18.6136 23.467 21.5624C23.467 21.8656 23.3586 22.1542 23.1594 22.3725H23.1608Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.3c12b3d7f94179e834c0bfb855848379.svg";
export { ForwardRef as ReactComponent };